
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface MarketingHeroProps {
  heroImage: string;
}

export const MarketingHero = ({ heroImage }: MarketingHeroProps) => {
  const navigate = useNavigate();
  
  return (
    <motion.div 
      className="text-center space-y-6 max-w-4xl mx-auto"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="relative rounded-2xl overflow-hidden mb-8 shadow-xl">
        <img 
          src={heroImage} 
          alt="Kid cooking and having fun" 
          className="w-full h-[400px] object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
          <span className="inline-block bg-accent/90 text-accent-foreground px-4 py-1 rounded-full text-sm font-medium mb-4">
            🧪 Kitchen Science for Kids!
          </span>
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Make Cooking Fun and Educational
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-6">
            Transform any recipe into an exciting learning adventure for young chefs!
          </p>
          <Button 
            size="lg" 
            onClick={() => navigate("/auth")}
            className="bg-primary hover:bg-primary/90"
          >
            Get Started
          </Button>
        </div>
      </div>
    </motion.div>
  );
};
